import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { getPatientName } from '../../../../../../features/patients';
import { IOrganizationDevicePatientRowProps } from './types';

export const OrganizationDevicePatientRow = ({ clickable, patient }: IOrganizationDevicePatientRowProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/app/patients/${patient?.id}`);
  };

  if (!patient) {
    return <span className="typography-paragraph-3">{t('organization.devices.field.patient.unknown')}</span>;
  }

  if (!clickable) {
    return <span className="typography-paragraph-3">{getPatientName(patient)}</span>;
  }

  return (
    <span className="typography-inline-link-3 text-text-link cursor-pointer" onClick={handleClick}>
      {getPatientName(patient)}
    </span>
  );
};
